// Send links to the four former variants to their own product pages.
if (location.pathname.endsWith('/products/mountain-cloud-sea-ceramic-incense-holder')) {
  const url = new URL(location.href);
  const handle = new Map([
  ['47129919750316', 'a-leaf-through-the-seasons-ceramic-incense-stick-holder'],
  ['47129919783084', 'lone-boat-fisherman-ceramic-incense-stick-holder'],
  ['47129919815852', 'fortune-and-prosperity-brown-ceramic-incense-stick-holder'],
  ['47129919848620', 'bamboo-brings-peace-ceramic-incense-stick-holder']
  ]).get(url.searchParams.get('variant'));
  if (handle) {
    url.pathname = url.pathname.replace(/[^/]+$/, handle);
    url.searchParams.delete('variant');
    location.replace(url.href);
  }
}

if (!customElements.get('holder-gallery-controller')) {
  customElements.define('holder-gallery-controller', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('product-info').then(() => {
        if (!this.isConnected) return;
        this.productInfo = this.closest('product-info');
        this.updateDescription(this.dataset.selectedStyle);
        this.originalUpdate = this.productInfo.updateMedia;
        this.productInfo.updateMedia = (html, featuredId) => {
          this.updateDescription(html.querySelector('holder-gallery-controller').dataset.selectedStyle);
          const current = this.productInfo.querySelector('media-gallery');
          const next = html.querySelector('media-gallery');
          if (!current || !next || !next.querySelector('[data-media-id]')) {
            throw new Error('Selected holder has no matching image group.');
          }
          current.replaceWith(document.importNode(next, true));
          const modal = this.productInfo.productModal?.querySelector('.product-media-modal__content');
          const nextModal = html.querySelector('product-modal .product-media-modal__content');
          if (modal && nextModal) modal.innerHTML = nextModal.innerHTML;
          this.productInfo.querySelector('media-gallery').setActiveMedia(
            `${this.productInfo.dataset.section}-${featuredId}`, false
          );
        };
      });
    }

    updateDescription(style) {
      const panels = this.productInfo.querySelectorAll('[data-holder-style]');
      if (![...panels].some(panel => panel.dataset.holderStyle === style)) {
        throw new Error('Selected holder has no matching description.');
      }
      panels.forEach(panel => { panel.hidden = panel.dataset.holderStyle !== style; });
    }

    disconnectedCallback() {
      if (this.productInfo && this.originalUpdate) this.productInfo.updateMedia = this.originalUpdate;
    }
  });
}
